<template>
  <div class="test-app-signin-view">
    <form>
      <label>Signin ID: <input type="text" v-model="loginID">(account_name)</label><br/>
      <label>Device ID: <input type="text" v-model="deviceID">(phone_device_id)</label><br/>
      <label>Device Authenticate Token: <input type="text" v-model="deviceAuthenticateToken">(device_authenticate_token)</label><br/>
      <button type="button" @click="doSignin">ログイン</button>
    </form>
    <div class="note">
      this is frontent vue test for localhost.<br/>
      prease input provided id and token.
    </div>
  </div>
</template>

<script>
import { PhoneDevice } from '@/api'
import router from '@/router'

export default {
  name: 'TestAppSigninView',

  data() {
    return {
      loginID: '',
      deviceID: '',
      deviceAuthenticateToken: ''
    }
  },

  methods: {
    doSignin () {
      if (
        this.loginID && this.loginID.length > 0 &&
        this.deviceID && this.deviceID.length > 0 &&
        this.deviceAuthenticateToken && this.deviceAuthenticateToken.length > 0
      ) {
        PhoneDevice.signInByChallengeToken({loginID: this.loginID, deviceID: this.deviceID, deviceAuthenticateToken: this.deviceAuthenticateToken }).then(res => {
          console.log(res)
          router.push({ path: '/address_book'})
        }).catch(error => {
          console.error(error)
        })
      } else {
        alert('prease input all id and token')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.test-app-signin-view {
  margin: 0;
  padding: 10px;
}
</style>